(function ($) {
	'use strict';

	function contactHref(type, value) {
		if (type === 'email') {
			return 'mailto:' + value;
		}

		if (type === 'phone') {
			return 'tel:' + value.replace(/\s+/g, '');
		}

		if (type === 'url') {
			return /^https?:\/\//i.test(value) ? value : 'https://' + value;
		}

		return null;
	}

	function renderContacts($container, contacts, emptyMessage) {
		$container.empty();
		var showIcons = !$container.hasClass('employer-company-details');

		if (!contacts.length) {
			$container.append($('<p>', { text: emptyMessage }));
			return;
		}

		$.each(contacts, function (_, contact) {
			var $item = $('<div>');
			var $value = $('<strong>');
			var href = contactHref(contact.type, contact.value);

			if (showIcons && contact.icon) {
				$item.append($('<i>', { class: 'uil ' + contact.icon, 'aria-hidden': 'true' }));
			}

			$item.append($('<span>', { text: contact.label }));

			if (href) {
				var attributes = { href: href, text: contact.value };

				if (contact.type === 'url') {
					attributes.target = '_blank';
					attributes.rel = 'noopener noreferrer';
				}

				$value.append($('<a>', attributes));
			} else {
				$value.text(contact.value);
			}

			$item.append($value);
			$container.append($item);
		});
	}

	function renderContactValue($target, contact, emptyMessage) {
		$target.empty();

		if (!contact) {
			$target.text(emptyMessage || window.___('Контактні дані не вказано.'));
			return;
		}

		var href = contactHref(contact.type, contact.value);

		if (href) {
			var attributes = {
				href: href,
				text: contact.value
			};

			if (contact.type === 'url') {
				attributes.target = '_blank';
				attributes.rel = 'noopener noreferrer';
			}

			$target.append($('<a>', attributes));
		} else {
			$target.text(contact.value);
		}
	}

	$(document).on('click', '[data-contact-reveal]', function () {
		var $button = $(this);
		var $container = $($button.attr('data-contact-target'));
		var field = $button.attr('data-contact-field') || '';
		var $valueTarget = $($button.attr('data-contact-value-target'));

		if ($button.prop('disabled') || (!$container.length && !$valueTarget.length)) {
			return;
		}

		$button.prop('disabled', true).addClass('is-loading');

		$.ajax({
			url: $button.attr('data-contact-reveal'),
			type: 'POST',
			data: field ? {field: field} : {},
			dataType: 'json',
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		}).done(function (response) {
			var contacts = response.contacts || [];

			if (field) {
				renderContactValue($valueTarget, contacts[0] || null, response.empty_message || '');
				$button.remove();
				return;
			}

			renderContacts($container, contacts, response.empty_message || '');
			$container.removeAttr('hidden');
			$button.remove();
		}).fail(function (xhr) {
			var serviceError = xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors.service
				? xhr.responseJSON.errors.service[0]
				: '';
			var message = serviceError || (xhr.status === 429
				? window.___('Забагато запитів. Спробуйте пізніше.')
				: window.___('Не вдалося завантажити контакти. Оновіть сторінку та спробуйте ще раз.'));

			if (field && $valueTarget.length) {
				$valueTarget.text(message);
			} else {
				$container.empty().append($('<p>', { text: message })).removeAttr('hidden');
			}

			$button.prop('disabled', false).removeClass('is-loading');
		});
	});
})(jQuery);
